// src/widgets/BottomBar/BottomBar.jsx
import React from 'react'
import { NavLink } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import s from './styles/BottomBar.module.scss'
import { useBottomBar } from './hooks/useBottomBar'

export const BottomBar = observer(() => {
	const { navItems } = useBottomBar()

	return (
		<nav className={s.bar}>
			{navItems.map(item => (
				<NavLink
					key={item.to}
					to={item.to}
					end={item.end}
					className={({ isActive }) => `${s.link} ${isActive ? s.active : ''}`}
				>
					<span className={s.icon}>
						{item.isMaterial ? (
							<span className="material-icons-outlined">{item.icon}</span>
						) : (
							item.icon
						)}
						{item.badgeText ? (
							<span className={s.icon__badge}>{item.badgeText}</span>
						) : null}
					</span>
					<span className={s.label}>{item.label}</span>
				</NavLink>
			))}
		</nav>
	)
})
